module.exports = __webpack_public_path__ + "img/lounaistieto_logo_avoimesti_musta.18a6ae47.png";